import { useMutation, useQueryClient } from '@tanstack/react-query';
import { container } from '@/app/container';
import { UsersRepositoryToken } from '../../di/tokens';

/**
 * Ações sobre a conta a partir do detalhe do usuário. Todas disparam e-mail ou
 * mudam credencial no provedor; `setTemporaryPassword` marca a conta para troca
 * obrigatória no próximo login → invalida o detalhe.
 */
export function useAccountActions(userId: string) {
  const queryClient = useQueryClient();
  const repository = container.resolve(UsersRepositoryToken);
  const invalidate = () =>
    void queryClient.invalidateQueries({ queryKey: ['users', userId] });

  const resetPassword = useMutation({
    mutationFn: (accountId: string) => repository.resetPassword(accountId),
  });
  const resendVerification = useMutation({
    mutationFn: (accountId: string) => repository.resendVerification(accountId),
  });
  // Reenvia o convite de primeiro acesso (link de DEFINIR senha) — distinto do
  // "reenviar verificação". `data.sent === false` = a pessoa já definiu a senha.
  const resendInvite = useMutation({
    mutationFn: (accountId: string) => repository.resendInvite(accountId),
  });
  const setTemporaryPassword = useMutation({
    mutationFn: (vars: { accountId: string; password: string }) =>
      repository.setTemporaryPassword(vars.accountId, vars.password),
    onSuccess: invalidate,
  });

  return {
    resetPassword,
    resendVerification,
    resendInvite,
    setTemporaryPassword,
  };
}
